module.exports = __webpack_public_path__ + "img/20180815_151538_149.7ebcd325.jpg";